import React from 'react';
import { ShowIf } from 'components/utils';
import { Link } from 'react-router';
import { Button } from '@blueprintjs/core';
import classnames from 'classnames';
import { isArray } from 'lodash';
import {LoadingDataTale} from 'modules/thanh-tra/datatable';

export default class DataTable extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      export: 'btn-green tt-export',
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
      divHeight: 195,
      down: false,
      scrollLeft: '',
      x: '',
      ie: false
    };

  }

  componentWillReceiveProps(nextProps) {
    let divHeight = 0;
    let obj = document.getElementsByClassName('table-header')[0];

    if( obj && obj.offsetHeight ) {
      divHeight=obj.offsetHeight;
    } else if(obj && obj.style && obj.style.pixelHeight) {
      divHeight=obj.style.pixelHeight;
    }
    this.setState({
      divHeight: divHeight + 2
    })
  }

  handleChangePageSize(size) {
    if ( this.props.parent && this.props.parent.handleChangePageSize ) {
      this.props.parent.handleChangePageSize.bind(this.props.parent, size);
    }
  }

  handlePageClick(page) {
    if ( this.props.parent && this.props.parent.handlePageC1lick ) {
      this.props.parent.handlePageClick.bind(this.props.parent, page);
    }
  }

  componentDidMount() {
    this.checkIe();
    if ( this.props.hideExport ) {
      this.setState({
        export: 'btn-green tt-export disable'
      });
    }

    let divHeight = 0;
    let obj = document.getElementsByClassName('table-header')[0];

    if( obj && obj.offsetHeight ) {
        divHeight=obj.offsetHeight;

    } else if( obj && obj.style.pixelHeight ) {
        divHeight=obj.style.pixelHeight;

    }
    this.setState({
      divHeight: divHeight + 2
    });
  }

  checkIe() {
    const ua = window.navigator.userAgent;
    const isIE = /MSIE|Trident/.test(ua);
    this.setState({
      ie: isIE
    });
  }

  handleExportExcel() {
  }

  handleExport() {
    this.props.handleExport()
  }

  getItemNull() {
    return (
      this.props.children
    )
  }

  handleDown(e) {
    if ( this.props.touchMove ) {
      let Item = document.getElementById('scrollItem');
      document.getElementById('scrollItem').classList.add("scrolling");
      this.state.down = true;
      this.state.scrollLeft = Item.scrollLeft;
      this.state.x = e.clientX;
    }
  }

  handleUp() {
    if ( this.props.touchMove ) {
      document.getElementById('scrollItem').classList.remove("scrolling");
      this.state.down = false;
    }
  }

  handleMove(e) {
    if ( this.props.touchMove ) {
      let Item = document.getElementById('scrollItem');
      if ( this.state.down == true ) {
        Item.scrollLeft = this.state.scrollLeft + this.state.x - e.clientX;
      }
    }
  }

  handleLeave() {
    if ( this.props.touchMove ) {
      document.getElementById('scrollItem').classList.remove("scrolling");
      this.state.down = false;
    }
  }

  openDialog() {
    this.props.openDialog();
  }

  handleContinue() {
    this.props.handleContinue();
  }

  onCheck() {
    this.props.onCheck();
  }

  render() {
    let pageNumber = this.props.pageData ? this.props.pageData.number : 0;
    let pageSize = this.props.pageData ? this.props.pageData.size : 0;
    let dataListItem = this.props.dataList.map((item, i) => {
      return (
      React.cloneElement(this.props.children, {
        key: i,
        count: (pageNumber * pageSize) + i + 1,
        item,
        parent: this.props.parent
      }))
    });

    return (
      <div className='wrapper-table'>
        {
          this.props.displayCount ?
            <div className="tc-total">
              Có <span>{this.props.pageData.totalElements}</span> kết quả tìm kiếm phù hợp với yêu cầu
            </div>
          :''
        }
        <div
          className={classnames('table-container', {
            'touch-move': this.props.touchMove,
            'checktracuu': this.props.checkTraCuu,
            'checktdgs': this.props.checkTDGS
          })}
          id='scrollItem'
          onMouseUp={this.handleUp.bind(this)}
          onMouseDown={this.handleDown.bind(this)}
          onMouseMove={this.handleMove.bind(this)}
          onMouseLeave={this.handleLeave.bind(this)}
        >
          <div className='scrollTTT' id='scrollTTT'>
            <table className="table-content thanh-tra-trung">
              <thead className="table-header hd">
                <tr>
                  <ShowIf condition={this.props.onDisableCheck !== true}>
                    <th className="table-header-col table-checkbox" style={{width: 40}}>
                      <label className="pt-control pt-checkbox pt-large">
                        <input type="checkbox" className="pt-large" name="" onChange={this.onCheck.bind(this)} checked={this.props.selectAllStatus}/>
                        <span className="pt-control-indicator"></span>
                      </label>
                    </th>
                  </ShowIf>
                  { this.props.header.map((item, i) => (
                      <th key={ i } className={classnames(`table-header-col ${item.className ? item.className : ''}`, {
                        'ie': this.state.ie,
                      }) } colSpan={ item.colSpan } style={ { width: item.width, minWidth: item.minWidth } }>
                        { item.name }
                      </th>
                    )
                  )}
                </tr>
              </thead>
              {isArray(this.props.dataList) && this.props.dataList.length === 0 && !this.props.tableLoading &&
                <tbody className="table-body">
                  <tr>
                    <td colSpan={this.props.header.length + this.props.plusColum}>Không có dữ liệu</td>
                  </tr>
              </tbody>
              }
              { this.props.tableLoading ? (
                <tbody className="table-body">
                  <tr className="table-loading">
                    <LoadingDataTale countLoading={12} colSpan={this.props.header.length + 1}/>
                  </tr>
                </tbody>
                ) : (
                  dataListItem
                ) }
            </table>
          </div>

          { !this.props.hidePagination && this.props.dataList.length>0 ? (
            <div className="pagination-wrap">
              <ShowIf condition={this.props.thanhTra || !this.props.hideButtonExport}>
                  <Button className={ this.state.export } text={ this.props.exporttext } onClick={ this.handleExport.bind(this) } />
              </ShowIf>
              { !this.props.hideButtonExport ? (
                <Button className={ this.state.export } text={ this.props.exporttext } onClick={ this.handleExportExcel.bind(this) } />
                ) : <div></div> }
                <ShowIf condition={this.props.showXuLy === true}>
                  {
                    this.props.btnTiepTuc ?
                    <Link onClick={this.handleContinue.bind(this)} className="btn-action btn-move action-todo mg-0"><span>Tiếp tục xử lý</span></Link>
                    :
                    <Link onClick={this.openDialog.bind(this)} className="btn-action btn-move action-todo mg-0"><span>Xử lý</span></Link>
                  }
                </ShowIf>
            </div>
            ) : null }
        </div>
      </div>
      );
  }
}
DataTable.defaultProps = {
  onChangeHeader: function() {
  },
  type: 'THUONG_XUYEN',
  labelPagination: 'Số hồ sơ',
  showAddMore: false,
  typeExport: 'TIEP_CONG_DAN',
  titleAddmore: 'Thêm mới',
  ThongKeBaoCao: false,
  LapBaoCao: false,
  addNew: false,
  addNewItem: function() {},
  dataList: [],
  header: [],
  plusColum: 0,
  displayCount: false,
  emptyMsg: 'Chưa có dữ liệu'
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/datatable/DataTableTTT.jsx